export default __webpack_public_path__ + "static/media/secureFUnding.4bc31373.png";